import { ItineraryStatus, WaypointActionStatusName, WaypointStatusName, ProcedureStatus } from '@caresend/types';

const itineraryStatusConfig = {
    /** Itinerary statuses */
    [ItineraryStatus.DRAFT
        || WaypointActionStatusName.DRAFT
        || WaypointStatusName.DRAFT]: {
        status: ItineraryStatus.DRAFT || WaypointActionStatusName.DRAFT || WaypointStatusName.DRAFT,
        friendlyName: 'Draft',
        disabled: true,
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--grey',
    },
    [ItineraryStatus.CREATED
        || ProcedureStatus.CREATED
        || WaypointStatusName.CREATED]: {
        status: ItineraryStatus.CREATED,
        friendlyName: 'Pending',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--orange',
    },
    [ItineraryStatus.ACCEPTED]: {
        status: ItineraryStatus.ACCEPTED,
        friendlyName: 'Confirmed',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--blue',
    },
    [ItineraryStatus.IN_PROGRESS
        || ProcedureStatus.IN_PROGRESS]: {
        status: ItineraryStatus.IN_PROGRESS,
        friendlyName: 'In Progress',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--yellow',
    },
    [ItineraryStatus.COMPLETED
        || ProcedureStatus.COMPLETED]: {
        status: ItineraryStatus.COMPLETED,
        friendlyName: 'Completed',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--green',
    },
    [ItineraryStatus.CANCELED
        || ProcedureStatus.CANCELED
        || WaypointActionStatusName.CANCELED]: {
        status: ItineraryStatus.CANCELED,
        friendlyName: 'Canceled',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--red',
    },
    /** Unique and shared waypoint action statuses */
    [WaypointActionStatusName.INCOMPLETE]: {
        status: WaypointActionStatusName.INCOMPLETE,
        friendlyName: 'Incomplete',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--yellow',
    },
    [WaypointActionStatusName.COMPLETE
        || WaypointStatusName.COMPLETE]: {
        status: WaypointActionStatusName.COMPLETE,
        friendlyName: 'Complete',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--green',
    },
    [WaypointActionStatusName.PACKED]: {
        status: WaypointActionStatusName.PACKED,
        friendlyName: 'Packed',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--blue',
    },
    /** Unique procedure statuses */
    [ProcedureStatus.FAILED]: {
        status: ProcedureStatus.FAILED,
        friendlyName: 'Failed',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--red',
    },
    /** Unique waypoint statuses */
    [WaypointStatusName.IN_ITINERARY]: {
        status: WaypointStatusName.IN_ITINERARY,
        friendlyName: 'In Itinerary',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--yellow',
    },
    [WaypointStatusName.TRANSIT_WAYPOINT]: {
        status: WaypointStatusName.TRANSIT_WAYPOINT,
        friendlyName: 'Transit',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--orange',
    },
    [WaypointStatusName.AT_WAYPOINT]: {
        status: WaypointStatusName.AT_WAYPOINT,
        friendlyName: 'At Waypoint',
        circleClass: 'ItineraryRelatedStatusView__status-indicator ItineraryRelatedStatusView__status-indicator--blue',
    },
};

export { itineraryStatusConfig };
